import { mmFetchWithResponse } from './mmFetchWithResponse';

const searchApi = {
    addVectorSearchConfig: async (config) => {
        const url = `api/search/v1/addVectorSearchConfig`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchStr: config.searchString, ...config }),
        });
    },
    addSearchString: async (searchStr) => {
        const url = `api/search/v1/llmCacheString`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchStr }),
        });
    },
    bustLLMCache: async (searchStr) => {
        const url = `api/search/v1/llmCacheBust`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchStr }),
        });
    },
    checkLLMSearchResults: async (searchStr, facilityID, options = {}) => {
        let url = `api/search/v1/llmCacheSearch?searchStr=${searchStr}&facilityID=${facilityID}`;
        if (options.forceCacheIfNotFound) {
            url += '&forceCacheIfNotFound=true';
        }
        return mmFetchWithResponse(url);
    },
    createBoostedSearch: async (searchString, vendorPromotionId, externalSku) => {
        const url = `api/search/v1/boost`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchString, vendorPromotionId, externalSku }),
        });
    },
    deleteBoostedSearch: async (id) => {
        const url = `api/search/v1/boost/delete`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ id }),
        });
    },
    getBoostedSearches: async () => {
        const url = `api/search/v1/boost`;
        return mmFetchWithResponse(url);
    },
    getLLMCacheList: async () => {
        const url = `api/search/v1/llmList`;
        return mmFetchWithResponse(url);
    },
    getVectorSearchConfigList: async () => {
        const url = `api/search/v1/vectorSearchConfigList`;
        return mmFetchWithResponse(url);
    },
    getSearchPackGroupParameters: async (facilityID) => {
        const url = `api/search/v1/weekYear?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    removeSearchString: async (searchStr) => {
        const url = `api/search/v1/removeLlmCache?searchStr=${searchStr}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchStr }),
        });
    },
    removeVectorSearchConfig: async (searchStr) => {
        const url = `api/search/v1/removeVectorSearchConfig?searchStr=${searchStr}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ searchStr }),
        });
    },
    vectorSearch: async (searchStr, facilityID, params = {}) => {
        let url = `api/search/v1/vectorSearch?searchStr=${searchStr}&facilityID=${facilityID}`;
        const { brandBoost, l1Boost, l2Boost, nameBoost, numResults, similarityThreshold } = params;

        if (similarityThreshold !== undefined && similarityThreshold !== null) {
            url += `&similarityThreshold=${similarityThreshold}`;
        }
        if (l2Boost !== undefined && l2Boost !== null) {
            url += `&l2Boost=${l2Boost}`;
        }
        if (l1Boost !== undefined && l1Boost !== null) {
            url += `&l1Boost=${l1Boost}`;
        }
        if (nameBoost !== undefined && nameBoost !== null) {
            url += `&itemNameBoost=${nameBoost}`;
        }
        if (brandBoost !== undefined && brandBoost !== null) {
            url += `&brandBoost=${brandBoost}`;
        }
        if (numResults !== undefined && numResults !== null) {
            url += `&numResults=${numResults}`;
        }

        return mmFetchWithResponse(url);
    },
};

export { searchApi };
